// FILE: client/src/actions/uploadActions.js

import * as actionTypes from "../constants/uploadConstants";
import api from "../utils/axiosInstance";
import { getApiErrorMessage } from "../utils/errorMessages";

const getErrorMessage = (error, fallback) =>
  getApiErrorMessage(error, { fallback });

export const uploadImages =
  (files, folder = "products") =>
  async (dispatch) => {
    try {
      dispatch({ type: actionTypes.UPLOAD_REQUEST });

      const safeFiles = Array.isArray(files) ? files : [];
      const safeFolder = encodeURIComponent(String(folder || "products"));

      if (!safeFiles.length) {
        throw new Error("Choose at least one image before uploading.");
      }

      const formData = new FormData();

      safeFiles.forEach((file) => {
        formData.append("images", file);
      });

      const { data } = await api.post(
        `/upload/admin?folder=${safeFolder}`,
        formData,
        {
          timeout: 120000,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const images = data?.images || [];

      dispatch({
        type: actionTypes.UPLOAD_SUCCESS,
        payload: images,
      });

      return images;
    } catch (error) {
      dispatch({
        type: actionTypes.UPLOAD_FAIL,
        payload: getErrorMessage(
          error,
          "We could not upload your images right now. Please try again later.",
        ),
      });

      throw error;
    }
  };

export const deleteImage = (image) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.DELETE_IMAGE_REQUEST });

    const public_id =
      image && typeof image === "object" ? image.public_id : image;
    const safePublicId = String(public_id || "").trim();

    if (!safePublicId) {
      throw new Error("Select a saved image before deleting it.");
    }

    const derivativePublicIds =
      image && typeof image === "object"
        ? Object.values(image.variants || {})
            .flatMap((variants) => (Array.isArray(variants) ? variants : []))
            .map((variant) => String(variant?.public_id || "").trim())
            .filter(Boolean)
        : [];

    const { data } = await api.delete(
      `/upload/admin/${encodeURIComponent(safePublicId)}`,
      { data: { derivativePublicIds } },
    );

    dispatch({
      type: actionTypes.DELETE_IMAGE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    dispatch({
      type: actionTypes.DELETE_IMAGE_FAIL,
      payload: getErrorMessage(
        error,
        "We could not delete that image right now. Please try again later.",
      ),
    });

    throw error;
  }
};
